import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-formulario-denuncia',
  templateUrl: './formulario-denuncia.component.html',
  styleUrls: ['./formulario-denuncia.component.css']
})
export class FormularioDenunciaComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
  
}
